// extracted by mini-css-extract-plugin
export var badge = "_t8-4";
export var selected = "_t8-1";
export var selectedOverlay = "_t8-5";
export var thumbnailButton = "_t8-0";
export var thumbnailFallback = "_t8-3";
export var thumbnailImage = "_t8-2";